import { History } from 'lucide-react';
import { Button } from '@/components/ui/Button.js';

export type DraftBannerProps = {
  /** `null` bo'lsa banner ko'rsatilmaydi. */
  savedAt: string | null;
  onRestore: () => void;
  onDiscard: () => void;
};

/**
 * «Saqlanmagan qoralama topildi».
 *
 * Avtomatik TIKLANMAYDI — xodim o'zi qaror qiladi. Avtomatik tiklansa,
 * boshqa xodim ataylab bekor qilgan o'zgarish qaytib kelardi va buni
 * hech kim sezmasdi.
 */
export function DraftBanner({ savedAt, onRestore, onDiscard }: DraftBannerProps) {
  if (!savedAt) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-3 border border-info-600 bg-info-50 px-4 py-2 text-sm text-info-600"
    >
      <History className="size-4 shrink-0" aria-hidden />
      <span className="flex-1 text-n-800">
        Saqlanmagan qoralama bor — u saqlangan holatdan yangiroq.
      </span>
      <Button size="sm" variant="outline" onClick={onRestore}>
        Tiklash
      </Button>
      <Button size="sm" variant="ghost" onClick={onDiscard}>
        O‘chirish
      </Button>
    </div>
  );
}
